export const FETCH_BUCKET_ID_REQUEST = 'FETCH_BUCKET_ID_REQUEST'
export const FETCH_BUCKET_ID_SUCCESS = 'FETCH_BUCKET_ID_SUCCESS'
export const FETCH_BUCKET_ID_FALIURE = 'FETCH_BUCKET_ID_FALIURE'
export const FETCH_OFFER_DATA_REQUEST = 'FETCH_OFFER_DATA_REQUEST'
export const FETCH_OFFER_DATA_SUCCESS = 'FETCH_OFFER_DATA_SUCCESS'
export const FETCH_OFFER_DATA_FALIURE = 'FETCH_OFFER_DATA_FALIURE'
